<template>
    <el-dialog :visible.sync="dialogVisible2" v-if="dialogVisible2" class="myDialog MessageDialog"
        :modal="true" :close-on-click-modal="false" :close-on-press-escape="false" :align-center="true" :show-close="true">
         <div class="notice-msg">
            <div class="notice-head">
                <div class="head-left"></div>
                <div class="head-title">{{messageTitle}}</div>
                <div class="head-right"><i class="el-icon-circle-close" @click="dialogVisible2 = false"></i></div>
            </div>
            <div class="notice-content">
                <div class="minhei">
                    <p v-for="(item,index) in messageBody" :key="index">{{item}}</p>
                </div>
            </div>

            <div class="notice-func" @click="dialogVisible2 = false">{{$t("common.know")}}</div>
        </div>
    </el-dialog>
</template>

<script>
import bus from '@/assets/js/bus';
export default {
    name:"MessageDialog",
    props:{
        dialogVisible: Boolean,
    },
    data() {
        return {
            dialogVisible2:this.dialogVisible,
            messageTitle:"",
            messageBody:[],
        };
    },
    created() {
    },
    methods:{
        show(msg) {
            this.messageTitle = msg.title;
            this.messageBody = msg.content;
            this.dialogVisible2 = true;
        },
        close() {
            let _this = this;
            setTimeout(() => {
                _this.dialogVisible2 = false;
                _this.messageTitle = "";
                _this.messageBody = "";
            }, 100);
        }
    }
}
</script>

<style lang="less">
.MessageDialog {
    .notice-msg {
        z-index: 10;
        margin: auto;
        border-radius: 10px;
        // border: 4px solid #D67314;
        // box-shadow: inset 0px 0px 8px 0px rgba(214, 115, 20, 1);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        .notice-head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #ffffff;
            font-size: 18px;
            font-weight: bolder;
            height: 45px;
            line-height:45px;
            // background: linear-gradient(0deg, #FF2667, #5A0015);;
            // border-radius: 10px 10px 0px 0px;
            .head-right,.head-left{
                width:30px;
                height: 100%;
                i{
                    font-size:20px;
                    cursor:pointer;
                    color: #3F5BB3;
                }
            }
            .head-title{
                flex:1;
            }
            img {
                width: 20px;
                height: 20px;
            }
        }
        .notice-content {
            margin: 0px; 
            max-height: 380px;
            // overflow-y: scroll;
            overflow-y: auto;
            overflow-x: hidden;
            word-wrap: break-word !important;
            flex:1;
            .minhei {
                // min-height: 200px;
                padding:10px 10px 20px 10px;
                white-space: pre-wrap;
                text-align: left;
                p{
                    margin:0px 0px 12px 0px;
                    font-size:12px;
                }
            }
            .minhei-border {
                border-bottom: 1px solid rgba(0, 0, 0, 0.2);
                text-align: left;
            }
            p{
                text-align: left;
                margin-top: 10px;
                color: #A7CBEA !important;
                word-wrap: break-word !important;
            }
            .text-right {
                text-align: right;
            }
            h1 {
                font-size: 16px;
            }
        }
        .notice-func{
            font-size: 14px;
            height: 36px;
            color:#ffffff;
            font-size:13px;
            text-align: center;
            line-height: 36px;
            margin: 20px 10px;
            cursor: pointer;
            // background: linear-gradient(90deg, #3F5BB3, #6387FA);
            // background: linear-gradient(90deg, #32D8FF, #006CEA);
            border-radius: 5px;
            background: linear-gradient(90deg, #32D8FF, #006CEA)!important;
            color: #ffffff!important;
            // background:url('~@/assets/images/qai/button.png') 0px 0px no-repeat;
            // background-size: 100% 100%;
        }
    }
}
</style>
